/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingMelcoModelsLogUpload
 */
export interface TrackingMelcoModelsLogUpload {
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogUpload
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogUpload
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogUpload
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogUpload
     */
    device_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsLogUpload
     */
    base64_file?: string | null;
}

export function TrackingMelcoModelsLogUploadFromJSON(json: any): TrackingMelcoModelsLogUpload {
    return TrackingMelcoModelsLogUploadFromJSONTyped(json, false);
}

export function TrackingMelcoModelsLogUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoModelsLogUpload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': !exists(json, 'category') ? undefined : json['category'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'device_name': !exists(json, 'device_name') ? undefined : json['device_name'],
        'base64_file': !exists(json, 'base64_file') ? undefined : json['base64_file'],
    };
}

export function TrackingMelcoModelsLogUploadToJSON(value?: TrackingMelcoModelsLogUpload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': value.category,
        'description': value.description,
        'file_name': value.file_name,
        'device_name': value.device_name,
        'base64_file': value.base64_file,
    };
}


